import React, { FC, useMemo } from 'react';
import xss from 'xss';

import styles from './Content.module.scss';

type ContentProps = {
  title?: string;
  description?: string;
};

const XSS_OPTIONS = {
  whiteList: {
    span: ['style'],
    p: ['style'],
    i: ['style'],
    b: ['style'],
    br: [],
  },
};

export const Content: FC<ContentProps> = ({ title, description }) => {
  const purifiedTitle = useMemo(() => {
    if (title) {
      return xss(title, XSS_OPTIONS);
    }
  }, [title]);

  const purifiedDescription = useMemo(() => {
    if (description) {
      return xss(description, XSS_OPTIONS);
    }
  }, [description]);

  return (
    <>
      {purifiedTitle && (
        <p dangerouslySetInnerHTML={{ __html: purifiedTitle }}
           className={styles.title} />
      )}
      {purifiedDescription && (
        <p dangerouslySetInnerHTML={{ __html: purifiedDescription }}
           className={styles.description} />
      )}
    </>
  );
};
